export enum BoothTypeEnum {
  ISLAND = 'Ilha',
  CORNER = 'Esquina',
  BOX = 'Box',
  ISLAND_END = 'Ponta de ilha',
}
